import { defHttp } from '/@/utils/http/axios';
import {
  ListParams,
  DatasetParams,
  CreateParams,
  InsertUploadDataParams,
  DatasetItem,
  DatasetGetResultModel,
  DatasetListGetResultModel,
  DatasetListItem,
  DatasetIdParams,
  InsertPointCloudParams,
  MakeFrameParams,
  MergeFrameParams,
  GetFrameParams,
  FrameListResult,
  MinioInfo,
  takeRecordParams,
  exportFileRecord,
  GetPresignedParams,
  ResponsePresignedParams,
  ChunkUploadInitParams,
  ChunkUploadStatusModel,
  ChunkUploadCompleteParams,
  UploadParams,
  ResponseUploadRecord,
  SelectedDataPa,
  splitFliterParams,
  TotalDataCountPa,
} from './model/datasetModel';
import { BasicIdParams } from '/@/api/model/baseModel';

enum Api {
  DATASET = '/dataset',
  DATA = '/data',
  DATASET_CLASS = '/datasetClass',
  MODEL_RUN = '/modelRun',
}

/**
 * @description: Get sample list value
 */

export const datasetListApi = (params: ListParams) =>
  defHttp.get<DatasetListGetResultModel>({
    url: `${Api.DATASET}/findByPage`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// 数据集页总览统计(老板 2026-09-20):页头统计卡四项,全局口径不随筛选变化
export const datasetOverviewApi = () =>
  defHttp.get<import('./model/datasetModel').DatasetOverviewStatistics>({
    url: `${Api.DATASET}/statistics/overview`,
  });

export const datasetApi = (params: DatasetParams) =>
  defHttp.get<DatasetGetResultModel>({
    url: `${Api.DATA}/findByPage`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const datasetObjectApi = (params: { dataIds: string }) =>
  defHttp.get<any>({
    url: `/annotate/data/listByDataIds`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const datasetDetailApi = (params: BasicIdParams) => {
  return defHttp.get<DatasetItem>(
    {
      url: `${Api.DATA}/info/${params.id}`,
      params,
      headers: {
        // @ts-ignore
        hiddenErrorMsg: true,
      },
    },
    { errorMessageMode: 'none' },
  );
};

export const createDatasetApi = (params: CreateParams) =>
  defHttp.post<DatasetItem>({
    url: `${Api.DATASET}/create`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const deleteDatasetApi = (params: BasicIdParams) =>
  defHttp.post<null>({
    url: `${Api.DATASET}/delete/${params.id}`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const insertUploadData = (params: InsertUploadDataParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/upload`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const insertUploadPointCloudApi = (params: InsertPointCloudParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/uploadCompressed`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const deleteBatchDataset = (params: { ids: number[]; datasetId: number }) =>
  defHttp.post<null>({
    url: `${Api.DATA}/deleteBatch`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// 多包合并(老板 2026-09-14):Scene_01+02+03 → Scene_01_02_03,合并后整包派发
export const mergeScenesApi = (params: { datasetId: number; sceneIds: number[] }) =>
  defHttp.post<{ id: number; name: string; frameCount: number }>({
    url: `${Api.DATA}/mergeScenes`,
    params,
  });

export const updateDataset = (params: { id: string | number; name: string }) =>
  defHttp.post<null>({
    url: `${Api.DATASET}/update/${params.id}`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const datasetItemDetail = (params: BasicIdParams) =>
  defHttp.get<DatasetListItem>({
    url: `${Api.DATASET}/info/${params.id}`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getMaxCountApi = (params: DatasetIdParams) =>
  defHttp.get<number>({
    url: `${Api.DATA}/selectMaxAnnotationCountByDatasetId`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const makeFrameSeriesApi = (params: MakeFrameParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/frames/combine`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const ungroupFrameSeriesApi = (params: MakeFrameParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/frames/remove`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const mergeFrameApi = (params: MergeFrameParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/frames/merge`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getFrameApi = (params: GetFrameParams) =>
  defHttp.get<FrameListResult>({
    url: `${Api.DATA}/frames/list`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getMinioInfo = () =>
  defHttp.get<MinioInfo>({
    url: `${Api.DATASET}/getMinioUserInfo`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getLockedByDataset = (params) =>
  defHttp.get<Nullable<any>>({
    url: `${Api.DATA}/findLockRecordIdByDatasetId`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// 标定自检(Phase 1.5 P1-1):同数据集各帧 camera_config 跨帧一致性比对
export const calibrationCheckApi = (params: { datasetId: number | string }) =>
  defHttp.get<any>({
    url: `${Api.DATA}/calibrationCheck`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const unLock = (params) =>
  defHttp.post<null>({
    url: `${Api.DATA}/unLock/${params.id}`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const takeRecordByData = (params: takeRecordParams) =>
  // 2026-09-17 修正:接口实际返回 data_annotation_record.id(数字),
  // 此前误标 null,调用侧只能靠 as 绕或误存 string
  defHttp.post<number>({
    url: `${Api.DATA}/annotate`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const checkRootByDataId = async (recordId: string, dataId: string) => {
  const res = await defHttp.get<any>({
    url: `${Api.DATA}/findDataAnnotationRecord/${recordId}`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
  return (res?.datas || []).some((item) => item.dataId === dataId);
};

export const takeRecordByDataModel = (params: takeRecordParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/annotateWithModel`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const exportData = (params: any) =>
  defHttp.get<null>({
    url: `${Api.DATA}/export`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const exportDataRecordCallBack = (params: { serialNumbers: string }) =>
  defHttp.get<exportFileRecord[]>({
    url: `${Api.DATA}/findExportRecordBySerialNumbers`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const generatePresignedUrl = (params: GetPresignedParams) =>
  defHttp.get<ResponsePresignedParams>({
    url: `${Api.DATA}/generatePresignedUrl`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const uploadDatasetApi = (params: UploadParams, signal?: any) =>
  defHttp.post<string>({
    url: `${Api.DATA}/upload`,
    signal: signal,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const findUploadRecordBySerialNumbers = (params: string, signal?: any) =>
  defHttp.get<ResponseUploadRecord[]>({
    url: `${Api.DATA}/findUploadRecordBySerialNumbers?serialNumbers=${params}`,
    signal: signal,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// 模型微调(老板 2026-09-16):通过现有数据优化模型效果
export const fineTuneApi = (params: {
  datasetId: number;
  dataIds: string[];
  baseModelId: number;
  epochs: number;
}) => defHttp.post<{ taskId: number; frames: number }>({ url: `${Api.DATA}/fineTune`, params });

export const fineTuneStatusApi = (taskId: number) =>
  defHttp.get<any>({ url: `${Api.DATA}/fineTune/status?taskId=${taskId}` });

// 数据简要(2026-09-16):通知点击按真实状态分流
export const getDataBrief = (ids: string) =>
  defHttp.get<any[]>({
    url: `${Api.DATA}/briefByIds?ids=${ids}`,
  });

// 当前用户进行中的导入任务(2026-09-15):数据集页"数据导入中"横幅 + 完成后自动刷新
export const findActiveUploadRecords = (signal?: any) =>
  defHttp.get<ResponseUploadRecord[]>({
    url: `${Api.DATA}/findActiveUploadRecords`,
    signal: signal,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// ---------- 大文件分片断点续传上传(Phase 1.5 P0-1) ----------
// uploadChunk(PUT 二进制 body)不走 defHttp —— 其 transform 会把 Blob body 误当 params 处理,
// 由 chunkUploader.ts 里用原生 axios 直接发。这里只封装三个 JSON 接口。

/** 初始化分片上传(同名同大小同数据集幂等,返回已有 uploadId) */
export const initChunkUploadApi = (params: ChunkUploadInitParams) =>
  defHttp.post<{ uploadId: string }>({
    url: `${Api.DATA}/initChunkUpload`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/** 查询已上传分片(断点续传依据) */
export const getChunkStatusApi = (uploadId: string, signal?: any) =>
  defHttp.get<ChunkUploadStatusModel>({
    url: `${Api.DATA}/chunkStatus`,
    params: { uploadId },
    signal: signal,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/** 完成分片上传:服务端合并,返回 fileUrl(拿它调 /data/upload 触发解析) */
export const completeChunkUploadApi = (params: ChunkUploadCompleteParams, signal?: any) =>
  defHttp.post<{ fileUrl: string }>({
    url: `${Api.DATA}/completeChunkUpload`,
    params,
    signal: signal,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getStatusNum = (params: { datasetId: number }) =>
  defHttp.get<ResponseUploadRecord[]>({
    url: `${Api.DATA}/getAnnotationStatusStatisticsByDatasetId`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const hasOntologyApi = (params: { datasetId: number }) =>
  defHttp.get<ResponseUploadRecord[]>({
    url: `${Api.DATASET}/findOntologyIsExistByDatasetId`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getScenario = (params: any) =>
  defHttp.get<any>({
    url: `${Api.DATA}/findByScenarioPage`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getDataByIds = (params: any) =>
  defHttp.get<any[]>({
    url: `${Api.DATA}/listByIds`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
export const getRelationByIds = (params: any) =>
  defHttp.get<any[]>({
    url: `${Api.DATA}/listRelationByIds`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getDatasetClass = (id) =>
  defHttp.get<any>({
    url: `${Api.DATASET_CLASS}/findAll/${id}`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const exportScenario = (params) =>
  defHttp.get<any>({
    url: `${Api.DATA}/scenarioExport`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const createByScenario = (params) =>
  defHttp.post<any>({
    url: `${Api.DATASET}/createByScenario`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getClassificationOptions = (params) =>
  defHttp.get<any>({
    url: `${Api.DATA}/classificationOption/findAll`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
export const splitFliter = (params: splitFliterParams) =>
  defHttp.post<null>({
    url: `${Api.DATA}/split/filter`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getTotalDataCount = (params: TotalDataCountPa) =>
  defHttp.get<any>({
    url: `${Api.DATA}/split/totalDataCount`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const splitDataSelected = (params: SelectedDataPa) =>
  defHttp.post<any>({
    url: `${Api.DATA}/split/dataIds`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getMoelResultApi = (datasetId: number) =>
  defHttp.get<any>({
    url: `${Api.MODEL_RUN}/getDatasetModelRunResult/${datasetId}`,

    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const getLockedRecordByDataset = (params: any) =>
  defHttp.get<any>({
    url: `${Api.DATA}/findLockRecordByDatasetId`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const unLockApi = (params: any) =>
  defHttp.post<null>({
    url: `${Api.DATA}/unLockByLockRecordIds`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

// Admin-only — list every active lock across all users for a dataset.
// Backend gates with @RequiresPermission("user:manage").
export const adminListLocks = (datasetId: number) =>
  defHttp.get<any[]>({ url: `${Api.DATA}/admin/locks`, params: { datasetId } });

// Admin-only — force-release any user's lock by record id.
export const adminForceUnLock = (recordId: number) =>
  defHttp.post<null>({ url: `${Api.DATA}/admin/forceUnLock/${recordId}` });
